import { apiRequest, apiRequestBlob } from "@/api/client";
import { TTL_6_HOURS, cacheKey, cachedFetch } from "@/lib/api-cache";
import type { SearchFilters, SearchRequest, SearchResponse } from "@/types/api";

/**
 * Executa a pesquisa avançada. Cacheada em memória por 6h (com dedupe de
 * requisições em voo) — o `signal` do chamador é ignorado: a obsolescência é
 * tratada no consumidor (guarda de efeito), e o dedupe compartilha a Promise.
 */
export function searchCompanies(
  request: SearchRequest,
  _signal?: AbortSignal,
): Promise<SearchResponse> {
  return cachedFetch(cacheKey("POST /search", request), TTL_6_HOURS, () =>
    apiRequest<SearchResponse>("/search", { method: "POST", body: request }),
  );
}

/**
 * Exporta os resultados em CSV com os filtros atuais e dispara o download no
 * navegador (`empresas.csv`). O backend limita a 50.000 linhas. NÃO é cacheado.
 */
export async function downloadCsv(filters: SearchFilters): Promise<void> {
  const blob = await apiRequestBlob("/export", {
    method: "POST",
    body: { filters },
  });
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = "empresas.csv";
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
